import React from 'react'

export default () => {
	return <h1>Page Not Found</h1>
}
